import React from "react";
import { withTranslation } from "react-i18next";
import { Badge } from "react-bootstrap";
import { SEVERITY_BADGE } from "../constants/timelineSeverity";
import {
  formatDeviation,
  formatSeverityLabel,
  formatTimelinePeriod,
  formatValue,
} from "../utils/timelineFormatters";
const TimelineNarrative = ({ t, dataPoints, selectedPeriod, onPeriodSelect }) => (
  <div className="anomaly-chart-card">
    <div className="chart-card-header">
      <h6>{t("MetricAnomalyTimeline.narrative.label")}</h6>
    </div>
    <div className="chart-card-body">
      <ul className="mat-timeline-narrative">
        {[...dataPoints].reverse().map((dp) => {
          const isSelected = selectedPeriod === dp.period;
          return (
            <li
              key={dp.period}
              className={`mat-narrative-item${isSelected ? " mat-narrative-item--selected" : ""}${dp.hasAnomaly ? " mat-narrative-item--anomaly" : ""}`}
            >
              <button
                type="button"
                className="mat-narrative-btn"
                onClick={() => onPeriodSelect(dp.period, false)}
              >
                <span className="mat-narrative-period">{formatTimelinePeriod(dp.period)}</span>
                {dp.hasAnomaly ? (
                  <span className="mat-narrative-body">
                    <span>{t("MetricAnomalyTimeline.narrativeAnomaly.label")}</span>
                    {dp.maxSeverity && (
                      <Badge bg={SEVERITY_BADGE[dp.maxSeverity] || "secondary"} className="ms-1">
                        {formatSeverityLabel(dp.maxSeverity, t)}
                      </Badge>
                    )}
                    <span className="mat-narrative-detail">
                      {t("MetricAnomalyTimeline.reportedValue.label")}: {formatValue(dp.value)}
                      {" · "}
                      {formatDeviation(dp.maxDeviationPct, t)}
                    </span>
                  </span>
                ) : (
                  <span className="mat-narrative-body mat-narrative-normal">
                    {t("MetricAnomalyTimeline.narrativeNormal.label")}
                    {" — "}
                    {formatValue(dp.value)}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  </div>
);

export default withTranslation()(TimelineNarrative);
